// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { deleteCallRecordRequestToJson, getCallRecordRequestToJson, getCallRecordResponseFromJson, getCallUsageRequestToJson, getCallUsageResponseFromJson, makeOutboundCallRequestToJson, makeOutboundCallResponseFromJson, transcribeAudioRequestToJson, transcribeAudioResponseFromJson, validateElevenLabsVoiceRequestToJson, validateElevenLabsVoiceResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getCallRecord(request) {
    const raw = await fetchRpc('voice.v1alpha1.VoiceService/GetCallRecord', getCallRecordRequestToJson(request));
    return getCallRecordResponseFromJson(raw);
}
export function getCallRecord$(request, options) {
    return defer(() => getCallRecordWithTransport$(getGlobalTransport(), request, options));
}
export function getCallRecordWithTransport$(transport, request, options) {
    return transport
        .post('voice.v1alpha1.VoiceService/GetCallRecord', getCallRecordRequestToJson(request), options)
        .pipe(map(resp => getCallRecordResponseFromJson(resp)));
}
export async function deleteCallRecord(request) {
    await fetchRpc('voice.v1alpha1.VoiceService/DeleteCallRecord', deleteCallRecordRequestToJson(request));
}
export function deleteCallRecord$(request, options) {
    return defer(() => deleteCallRecordWithTransport$(getGlobalTransport(), request, options));
}
export function deleteCallRecordWithTransport$(transport, request, options) {
    return transport
        .post('voice.v1alpha1.VoiceService/DeleteCallRecord', deleteCallRecordRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getCallUsage(request) {
    const raw = await fetchRpc('voice.v1alpha1.VoiceService/GetCallUsage', getCallUsageRequestToJson(request));
    return getCallUsageResponseFromJson(raw);
}
export function getCallUsage$(request, options) {
    return defer(() => getCallUsageWithTransport$(getGlobalTransport(), request, options));
}
export function getCallUsageWithTransport$(transport, request, options) {
    return transport
        .post('voice.v1alpha1.VoiceService/GetCallUsage', getCallUsageRequestToJson(request), options)
        .pipe(map(resp => getCallUsageResponseFromJson(resp)));
}
export async function transcribeAudio(request) {
    const raw = await fetchRpc('voice.v1alpha1.VoiceService/TranscribeAudio', transcribeAudioRequestToJson(request));
    return transcribeAudioResponseFromJson(raw);
}
export function transcribeAudio$(request, options) {
    return defer(() => transcribeAudioWithTransport$(getGlobalTransport(), request, options));
}
export function transcribeAudioWithTransport$(transport, request, options) {
    return transport
        .post('voice.v1alpha1.VoiceService/TranscribeAudio', transcribeAudioRequestToJson(request), options)
        .pipe(map(resp => transcribeAudioResponseFromJson(resp)));
}
export async function makeOutboundCall(request) {
    const raw = await fetchRpc('voice.v1alpha1.VoiceService/MakeOutboundCall', makeOutboundCallRequestToJson(request));
    return makeOutboundCallResponseFromJson(raw);
}
export function makeOutboundCall$(request, options) {
    return defer(() => makeOutboundCallWithTransport$(getGlobalTransport(), request, options));
}
export function makeOutboundCallWithTransport$(transport, request, options) {
    return transport
        .post('voice.v1alpha1.VoiceService/MakeOutboundCall', makeOutboundCallRequestToJson(request), options)
        .pipe(map(resp => makeOutboundCallResponseFromJson(resp)));
}
export async function validateElevenLabsVoice(request) {
    const raw = await fetchRpc('voice.v1alpha1.VoiceService/ValidateElevenLabsVoice', validateElevenLabsVoiceRequestToJson(request));
    return validateElevenLabsVoiceResponseFromJson(raw);
}
export function validateElevenLabsVoice$(request, options) {
    return defer(() => validateElevenLabsVoiceWithTransport$(getGlobalTransport(), request, options));
}
export function validateElevenLabsVoiceWithTransport$(transport, request, options) {
    return transport
        .post('voice.v1alpha1.VoiceService/ValidateElevenLabsVoice', validateElevenLabsVoiceRequestToJson(request), options)
        .pipe(map(resp => validateElevenLabsVoiceResponseFromJson(resp)));
}
